import api from './api-adapter';
import parseGame from './../util/parse-game';

export async function load (size) {
  const params = {
    page: 1,
    page_size: size,
    market: 'tr_1x2',
    flat: 1
  };
  // const { results } = await api.get('/featured/', { params });
  const data = await api.get('/featured/', { params });
  const { results } = data;
  return results.map(parseGame);
}
